<!--
  ~ Copyright (C) 2017 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<og-icon [name]="getIconName()" [ngClass]="getIconClass()"></og-icon>
